"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var PhoneInfo_1 = require("./PhoneInfo");
var EmailInfo_1 = require("./EmailInfo");
var ClientInfo = /** @class */ (function () {
    function ClientInfo(source) {
        this.id = source ? source.id : -1;
        this.accountId = source ? source.accountId : -1;
        this.name = source ? source.name : '';
        this.firstName = source ? source.firstName : '';
        this.secondName = source ? source.secondName : '';
        this.patronymic = source ? source.patronymic : '';
        this.phones = source ? source.phones.map(function (p) { return new PhoneInfo_1.PhoneInfo(p); }) : [];
        this.emails = source ? source.emails.map(function (e) { return new EmailInfo_1.EmailInfo(e); }) : [];
        this.isLegalEntity = source ? source.isLegalEntity : false;
        this.inn = source ? source.inn : '';
        this.isVip = source ? source.isVip : true;
        this.ordersCount = source ? source.ordersCount : 0;
        this.registrationDate = source ? source.registrationDate : null;
        this.customerCompanyId = source ? source.customerCompanyId : null;
        this.employeeBrands = source ? source.employeeBrands : [];
        this.roles = source ? source.roles : [];
        this.description = source ? source.description : '';
    }
    ClientInfo.fromInnData = function (data) {
        if (data === undefined || data === null)
            return undefined;
        var newClientInfo = new ClientInfo();
        newClientInfo.name = data.name.short_with_opf;
        newClientInfo.inn = data.inn;
        newClientInfo.isLegalEntity = true;
        return newClientInfo;
    };
    ClientInfo.prototype.getCopy = function () {
        return new ClientInfo(this);
    };
    Object.defineProperty(ClientInfo.prototype, "PhonesString", {
        get: function () {
            return this.phones.map(function (p) { return p.phoneNumber; }).join(';');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ClientInfo.prototype, "EmailsString", {
        get: function () {
            return this.emails.map(function (p) { return p.email; }).join(';');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ClientInfo.prototype, "EmployeeBrandsString", {
        get: function () {
            return this.employeeBrands.map(function (p) { return p.brandName; }).join(';');
        },
        enumerable: true,
        configurable: true
    });
    return ClientInfo;
}());
exports.ClientInfo = ClientInfo;
//# sourceMappingURL=ClientInfo.js.map